/* eslint-disable array-bracket-newline */
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Address } from 'wagmi';
import OpenOrdersTable from './Table';
import OpenOrdersTableMobile from './TableMobile';
import { IStore } from '../../../reducers';
import {
  actionCancelCexOrder,
  actionGetOpenOrdersDone,
  actionGetOpenOrders,
} from '../../../actions/cex_orders';
import { supportedCEXTradingExchanges } from '../../Trading';

export interface ICexOpenOrder {
  uuid: string;
  wallet: Address;
  exchange: number;
  pair: string;
  type: number;
  side: number;
  base_amount: number;
  status: number;
  fillBaseAmount: number;
  created_at: number;
  updated_at: number;
  closed_at: number;
}

export interface IOpenOrdersDataLayerProps {
  width?: number;
  isMobile?: boolean;
}

const OpenOrders = ({ width, isMobile }: IOpenOrdersDataLayerProps) => {
  const loggedIn = useSelector((state: IStore) => state.auth.loggedIn);
  const { exchange, base, quote } = useSelector(
    (state: IStore) => state.current
  );
  const timezone = useSelector((state: IStore) => state.timezone.current);
  const orders = useSelector((state: IStore) => state.cex_orders.openOrders);
  const loading = useSelector((state: IStore) => state.cex_orders.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (loggedIn && supportedCEXTradingExchanges.includes(exchange)) {
      dispatch(actionGetOpenOrders());
    } else {
      dispatch(actionGetOpenOrdersDone([]));
    }
  }, [loggedIn, base, exchange, quote, dispatch]);

  const onCancel = useCallback(
    async (id: string) => {
      if (loggedIn && supportedCEXTradingExchanges.includes(exchange)) {
        dispatch(actionCancelCexOrder(id));
      }
    },
    [loggedIn, dispatch, exchange]
  );

  return isMobile ? (
    <OpenOrdersTableMobile
      orders={orders}
      base={base}
      quote={quote}
      timezone={timezone}
      loading={loading}
      onCancel={onCancel}
    />
  ) : (
    <OpenOrdersTable
      orders={orders}
      base={base}
      quote={quote}
      timezone={timezone}
      width={width}
      loading={loading}
      onCancel={onCancel}
    />
  );
};
export default OpenOrders;
